import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTypes } from "../../../../constants";
import { Container, Grid } from "@mui/material";

import BreadcrumbBuilder from "../BreadcrumbBuilder";
import Fetching from "../../../Common/Fetching";
import TMSAvatar from "../TMSAvatar";

import { eventAttendanceBadge } from "./EventFunctions";

import tmsActions from "../../../../actions/tmsActions";
import { getEvent, isFetching } from "../../../../reducers";

import EventCard from "../../CENT/Event/EventCard";

const Event = ({ match }) => {
    const event = useSelector((state) => getEvent(state, match.params.id));
    const dispatch = useDispatch();
    const isLoading = useSelector((state) =>
        isFetching(state, DataTypes.TMS_EVENT)
    );

    useEffect(() => {
        dispatch(tmsActions.getEvent("C-TMS", match.params.id));
    }, [dispatch, match.params.id]);

    const image =
        event?.image ??
        "https://cdn.premierit.com/images/banners/themes/office/bnr-office-meeting.png";

    const badge = eventAttendanceBadge(event?.attendance?.status);
    const avatar = <TMSAvatar type="event" badge={badge} />;

    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {isLoading && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                <Grid item xs={12}>
                    <EventCard event={event} image={image} avatar={avatar} />
                </Grid>
            </Grid>
        </Container>
    );
};

export default Event;
